import React from 'react';
import { Box, TextField, MenuItem, Button, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

const AdminToolbar = ({
    searchValue,
    onSearchChange,
    filterValue,
    onFilterChange,
    filterOptions = [],
    onCreate,
    createLabel = 'Tạo Mới',
    placeholder = 'Tìm kiếm...'
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center' }}>
            <TextField
                variant="outlined"
                size="small"
                placeholder={placeholder}
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ color: '#94a3b8' }} />
                        </InputAdornment>
                    ),
                    sx: { color: 'white', bgcolor: '#1e293b', borderRadius: 1 }
                }}
                sx={{ flexGrow: 1, minWidth: '250px' }}
            />

            {filterOptions.length > 0 && (
                <TextField
                    select
                    variant="outlined"
                    size="small"
                    value={filterValue}
                    onChange={(e) => onFilterChange(e.target.value)}
                    sx={{ width: '150px', bgcolor: '#1e293b', borderRadius: 1, '& .MuiSelect-select': { color: 'white' } }}
                >
                    {filterOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}

            {onCreate && (
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onCreate}
                    sx={{ bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}
                >
                    {createLabel}
                </Button>
            )}
        </Box>
    );
};

export default AdminToolbar;
